<script lang="ts">
    import { cn } from "../cn";
    export let variant:
        | "default"
        | "secondary"
        | "destructive"
        | "success"
        | "warning"
        | "outline" = "default";
    let className = "";
    export { className as class };

    const variants: Record<string, string> = {
        default:
            "bg-[var(--primary)]/15 text-[color-mix(in_oklch,var(--primary)_85%,white)] border border-[var(--primary)]/25",
        secondary:
            "bg-[var(--secondary)] text-[var(--secondary-foreground)] border border-transparent",
        destructive:
            "bg-[var(--destructive)]/15 text-[color-mix(in_oklch,var(--destructive)_75%,white)] border border-[var(--destructive)]/30",
        success:
            "bg-[var(--success)]/15 text-[color-mix(in_oklch,var(--success)_70%,white)] border border-[var(--success)]/30",
        warning:
            "bg-[var(--warning)]/15 text-[color-mix(in_oklch,var(--warning)_75%,white)] border border-[var(--warning)]/30",
        outline:
            "border border-[var(--border)] text-[var(--foreground)] bg-transparent",
    };
</script>

<span
    class={cn(
        "inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-medium leading-none uppercase tracking-wider",
        variants[variant],
        className,
    )}
>
    <slot />
</span>
